import firebase from 'firebase/compat/app';

const STOCKS = ['META', 'VTSAX', 'BTC'];

interface StockData {
  symbol: string;
  price: string;
}

export function createStockPlaceholders() {
  const stockPricesDiv = document.getElementById('stock-prices');
  if (!stockPricesDiv) {
    return;
  }
  for (const stock of STOCKS) {
    const stockDiv = document.createElement('div');
    stockDiv.classList.add('stock');
    stockDiv.id = `stock-${stock}`;
    const stockLink = document.createElement('a');
    stockLink.href = `https://www.google.com/search?q=${stock} price`;
    stockLink.target = '_blank';
    const symbolName = document.createElement('span');
    symbolName.classList.add('stock-symbol');
    symbolName.textContent = stock;
    stockLink.appendChild(symbolName);
    const stockPrice = document.createElement('span');
    stockPrice.classList.add('stock-price');
    stockPrice.innerHTML = '...';
    stockLink.appendChild(stockPrice);
    stockDiv.appendChild(stockLink);
    stockPricesDiv.appendChild(stockDiv);
  }
}

async function getStockData(): Promise<StockData[]> {
  try {
    const user = firebase.auth().currentUser;
    if (!user) {
      return [];
    }
    const token = await user.getIdToken();
    const response = await fetch('/apiv2/stocks', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Fetch error:', response.status, response.statusText, errorText);
      throw new Error(`Failed to fetch stock data: ${response.status} ${response.statusText} - ${errorText}`);
    }
    return await response.json();
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function displayStockPrices() {
  const stockData = await getStockData();
  // Update placeholders with fetched data
  for (const stock of stockData) {
    const stockDiv = document.getElementById(`stock-${stock.symbol}`);
    if (stockDiv) {
      const stockPrice = stockDiv.querySelector('.stock-price');
      if (stockPrice) {
        const currentPrice = parseFloat(stock.price);

        stockPrice.innerHTML = `<span class="dollar-sign">$</span>${Math.floor(currentPrice).toLocaleString('en-US')}`;
      }
    }
  }
  // Handle failed stocks
  for (const stock of STOCKS) {
    if (!stockData.find((s) => s.symbol === stock)) {
      const stockDiv = document.getElementById(`stock-${stock}`);
      if (stockDiv) {
        const stockPrice = stockDiv.querySelector('.stock-price');
        if (stockPrice) {
          stockPrice.innerHTML = '???';
        }
      }
    }
  }
}
